export class FileHelper {
	static downloadFileFromUrl(url: string): void {
		const a = document.createElement('a');
		document.body.appendChild(a);
		a.style.display = 'none';
		a.href = url;
		a.click();
		window.URL.revokeObjectURL(url);
	}
}
